"use client";

import { c as _c } from "react/compiler-runtime";
import DropsListItemDeleteDropModal from "@/components/drops/view/item/options/delete/DropsListItemDeleteDropModal";
import CommonAnimationOpacity from "@/components/utils/animation/CommonAnimationOpacity";
import CommonAnimationWrapper from "@/components/utils/animation/CommonAnimationWrapper";
import CommonDropdownItemsDefaultWrapper from "@/components/utils/select/dropdown/CommonDropdownItemsDefaultWrapper";
import { useAuth } from "@/components/auth/Auth";
import { getFileInfoFromUrl } from "@/helpers/file.helpers";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { useCanShowDropCurationsAction } from "@/hooks/drops/useCanShowDropCurationsAction";
import { useDropInteractionRules } from "@/hooks/drops/useDropInteractionRules";
import { EllipsisHorizontalIcon } from "@heroicons/react/24/outline";
import { useMemo, useRef, useState } from "react";
import { Tooltip } from "react-tooltip";
import WaveDropActionsCopyLink from "./WaveDropActionsCopyLink";
import WaveDropCurationsActionIcon from "./WaveDropCurationsActionIcon";
import WaveDropCurationsDialog from "./WaveDropCurationsDialog";
import WaveDropActionsDownload from "./WaveDropActionsDownload";
import WaveDropActionsMarkUnread from "./WaveDropActionsMarkUnread";
import WaveDropActionsOpen from "./WaveDropActionsOpen";
import WaveDropActionsOptions from "./WaveDropActionsOptions";
import WaveDropActionsRestoreLinkPreviews from "./WaveDropActionsRestoreLinkPreviews";
import WaveDropActionsSetPinnedDrop from "./WaveDropActionsSetPinnedDrop";
interface WaveDropActionsMoreProps {
  readonly drop: ExtendedDrop;
  readonly onOpenChange?: (isOpen: boolean) => void;
}
export default function WaveDropActionsMore(t0) {
  const $ = _c(79);
  const {
    drop,
    onOpenChange
  } = t0;
  const {
    connectedProfile
  } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isCurationsDialogOpen, setIsCurationsDialogOpen] = useState(false);
  const buttonRef = useRef(null);
  const {
    canDelete,
    canSetPinnedDrop
  } = useDropInteractionRules(drop);
  const t1 = drop.id;
  let t2;
  if ($[0] !== drop.id) {
    t2 = drop.id.startsWith("temp-");
    $[0] = drop.id;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = drop.wave.authenticated_user_admin === true;
  const t4 = (isOpen || isCurationsDialogOpen) && Boolean(connectedProfile?.handle);
  let t5;
  if ($[2] !== drop.id || $[3] !== t2 || $[4] !== t3 || $[5] !== t4) {
    t5 = {
      dropId: t1,
      isTemporaryDrop: t2,
      isWaveAdmin: t3,
      enabled: t4
    };
    $[2] = drop.id;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const showCurationsAction = useCanShowDropCurationsAction(t5);
  let t6;
  if ($[7] !== onOpenChange) {
    t6 = newIsOpen => {
      setIsOpen(newIsOpen);
      onOpenChange?.(newIsOpen);
    };
    $[7] = onOpenChange;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const handleOpenChange = t6;
  let t7;
  if ($[9] !== handleOpenChange) {
    t7 = () => handleOpenChange(false);
    $[9] = handleOpenChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const closeDropdown = t7;
  let t8;
  if ($[11] !== handleOpenChange) {
    t8 = () => {
      handleOpenChange(false);
      setIsDeleteModalOpen(true);
    };
    $[11] = handleOpenChange;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  const handleDeleteClick = t8;
  let t9;
  if ($[13] !== drop.parts) {
    bb0: {
      const media = drop.parts.at(0)?.media.at(0);
      const url = media?.url;
      if (!url) {
        t9 = null;
        break bb0;
      }
      t9 = getFileInfoFromUrl(url);
    }
    $[13] = drop.parts;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const mediaInfo = t9;
  let t10;
  if ($[15] !== handleOpenChange || $[16] !== isOpen) {
    t10 = () => handleOpenChange(!isOpen);
    $[15] = handleOpenChange;
    $[16] = isOpen;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const t11 = `more-actions-${drop.id}`;
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <EllipsisHorizontalIcon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-transition tw-duration-300 tw-ease-out" />;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== isOpen || $[20] !== t10 || $[21] !== t11) {
    t13 = <button ref={buttonRef} className="tw-flex tw-h-7 tw-w-7 tw-cursor-pointer tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-400 tw-transition-all tw-duration-200 tw-ease-out desktop-hover:hover:tw-bg-iron-800 desktop-hover:hover:tw-text-iron-200" onClick={t10} aria-label="More actions" aria-haspopup="true" aria-expanded={isOpen} data-tooltip-id={t11}>{t12}</button>;
    $[19] = isOpen;
    $[20] = t10;
    $[21] = t11;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== drop.id || $[24] !== isOpen) {
    t14 = !isOpen && <Tooltip id={`more-actions-${drop.id}`} place="top" offset={8} opacity={1} style={{
      padding: "4px 8px",
      background: "#37373E",
      color: "white",
      fontSize: "13px",
      fontWeight: 500,
      borderRadius: "6px",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
      zIndex: 99999,
      pointerEvents: "none"
    }}><span className="tw-text-xs">More</span></Tooltip>;
    $[23] = drop.id;
    $[24] = isOpen;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  let t15;
  let t16;
  if ($[26] !== closeDropdown || $[27] !== drop) {
    t15 = <WaveDropActionsMarkUnread drop={drop} isDropdownItem={true} onMarkUnread={closeDropdown} />;
    t16 = <WaveDropActionsCopyLink drop={drop} isDropdownItem={true} onCopy={closeDropdown} />;
    $[26] = closeDropdown;
    $[27] = drop;
    $[28] = t15;
    $[29] = t16;
  } else {
    t15 = $[28];
    t16 = $[29];
  }
  let t17;
  if ($[30] !== closeDropdown || $[31] !== showCurationsAction) {
    t17 = showCurationsAction && <button type="button" onClick={event => {
      event.stopPropagation();
      closeDropdown();
      setIsCurationsDialogOpen(true);
    }} className="tw-flex tw-w-full tw-cursor-pointer tw-items-center tw-gap-x-3 tw-rounded-lg tw-border-0 tw-bg-transparent tw-px-3 tw-py-2 tw-text-iron-300 tw-transition-colors tw-duration-200 desktop-hover:hover:tw-bg-iron-800"><WaveDropCurationsActionIcon className="tw-size-4 tw-flex-shrink-0" /><span className="tw-text-sm tw-font-medium">Curate</span></button>;
    $[30] = closeDropdown;
    $[31] = showCurationsAction;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  let t19;
  if ($[33] !== closeDropdown || $[34] !== drop) {
    t18 = <WaveDropActionsRestoreLinkPreviews drop={drop} onRestored={closeDropdown} />;
    t19 = <WaveDropActionsOpen drop={drop} isDropdownItem={true} onOpen={closeDropdown} />;
    $[33] = closeDropdown;
    $[34] = drop;
    $[35] = t18;
    $[36] = t19;
  } else {
    t18 = $[35];
    t19 = $[36];
  }
  let t20;
  if ($[37] !== closeDropdown || $[38] !== drop.id || $[39] !== drop.parts || $[40] !== mediaInfo) {
    t20 = mediaInfo && <WaveDropActionsDownload href={drop.parts.at(0)?.media.at(0)?.url ?? ""} name={mediaInfo.name} extension={mediaInfo.extension} tooltipId={`download-media-${drop.id}`} isDropdownItem={true} onDownload={closeDropdown} />;
    $[37] = closeDropdown;
    $[38] = drop.id;
    $[39] = drop.parts;
    $[40] = mediaInfo;
    $[41] = t20;
  } else {
    t20 = $[41];
  }
  let t21;
  if ($[42] !== canSetPinnedDrop || $[43] !== closeDropdown || $[44] !== drop) {
    t21 = canSetPinnedDrop && <WaveDropActionsSetPinnedDrop drop={drop} onPinnedDropSet={closeDropdown} />;
    $[42] = canSetPinnedDrop;
    $[43] = closeDropdown;
    $[44] = drop;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== canDelete || $[47] !== drop || $[48] !== handleDeleteClick) {
    t22 = canDelete && <WaveDropActionsOptions drop={drop} isDropdownItem={true} onDelete={handleDeleteClick} />;
    $[46] = canDelete;
    $[47] = drop;
    $[48] = handleDeleteClick;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== t15 || $[51] !== t16 || $[52] !== t17 || $[53] !== t18 || $[54] !== t19 || $[55] !== t20 || $[56] !== t21 || $[57] !== t22) {
    t23 = <li className="tw-list-none"><div className="tw-flex tw-flex-col tw-gap-y-1 tw-py-1">{t15}{t16}{t17}{t18}{t19}{t20}{t21}{t22}</div></li>;
    $[50] = t15;
    $[51] = t16;
    $[52] = t17;
    $[53] = t18;
    $[54] = t19;
    $[55] = t20;
    $[56] = t21;
    $[57] = t22;
    $[58] = t23;
  } else {
    t23 = $[58];
  }
  let t24;
  if ($[59] !== handleOpenChange || $[60] !== isOpen || $[61] !== t23) {
    t24 = <CommonDropdownItemsDefaultWrapper isOpen={isOpen} setOpen={handleOpenChange} buttonRef={buttonRef}>{t23}</CommonDropdownItemsDefaultWrapper>;
    $[59] = handleOpenChange;
    $[60] = isOpen;
    $[61] = t23;
    $[62] = t24;
  } else {
    t24 = $[62];
  }
  let t25;
  if ($[63] !== drop || $[64] !== isDeleteModalOpen) {
    t25 = isDeleteModalOpen && <CommonAnimationOpacity key="modal" elementClasses="tw-absolute tw-z-50" elementRole="dialog" onClicked={_temp}><DropsListItemDeleteDropModal drop={drop} closeModal={() => setIsDeleteModalOpen(false)} /></CommonAnimationOpacity>;
    $[63] = drop;
    $[64] = isDeleteModalOpen;
    $[65] = t25;
  } else {
    t25 = $[65];
  }
  let t26;
  if ($[66] !== t25) {
    t26 = <CommonAnimationWrapper mode="sync" initial={true}>{t25}</CommonAnimationWrapper>;
    $[66] = t25;
    $[67] = t26;
  } else {
    t26 = $[67];
  }
  let t27;
  if ($[68] !== drop.id || $[69] !== drop.wave || $[70] !== isCurationsDialogOpen || $[71] !== showCurationsAction) {
    t27 = showCurationsAction && <WaveDropCurationsDialog dropId={drop.id} wave={drop.wave} isOpen={isCurationsDialogOpen} onClose={() => setIsCurationsDialogOpen(false)} />;
    $[68] = drop.id;
    $[69] = drop.wave;
    $[70] = isCurationsDialogOpen;
    $[71] = showCurationsAction;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== t13 || $[74] !== t14 || $[75] !== t24 || $[76] !== t26 || $[77] !== t27) {
    t28 = <>{t13}{t14}{t24}{t26}{t27}</>;
    $[73] = t13;
    $[74] = t14;
    $[75] = t24;
    $[76] = t26;
    $[77] = t27;
    $[78] = t28;
  } else {
    t28 = $[78];
  }
  return t28;
}
function _temp(e) {
  return e.stopPropagation();
}